import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { CoreService } from 'src/app/core/services/core.service';

import { StorageService } from 'src/app/core/storage/storage.service';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { ModalConfirmRequestComponent } from 'src/app/shared/components/modal-confirm-request/modal-confirm-request.component';
import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { Stock } from 'src/app/shared/model/campaign.model';
import {
  OrderRequest,
  ReplacementVehicleRequest
} from 'src/app/shared/model/order.model';
import { User } from 'src/app/shared/model/user.model';

@Component({
  standalone: true,
  selector: 'app-campaign-request',
  templateUrl: './campaign-request.component.html',
  styleUrls: ['./campaign-request.component.scss'],
  imports: [CommonModule, I18NextModule, RouterModule, StepperComponent]
})
export class CampaignRequestComponent implements OnInit {
  @ViewChild('stepperHeader') stepperHeader!: ElementRef;

  selectedVehicle!: Stock;
  user!: User;
  requestType = 'CAMPAIGN';
  replacementVehicle?: ReplacementVehicleRequest | null;
  requestObj!: OrderRequest;

  steps = new Map<string, boolean>();

  landing2 = false;
  loading = false;

  constructor(
    private storageService: StorageService,
    private coreService: CoreService,
    public dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (this.storageService.get('stock')) {
      this.selectedVehicle = this.storageService.get('stock');
    }
    if (this.storageService.get('config')) {
      this.user = this.storageService.get('config');
    }
    this.landing2 = this.storageService.get('landing2') || false;

    this.setSteps();
    setTimeout(() => {
      this.adjustStepper();
    }, 100);
  }

  setSteps() {
    this.steps.set('request-info', false);
    this.steps.set('stockVehicle', true);
    this.steps.set('car-config', false);
    this.steps.set('replacementvehicle', false);
    this.steps.set('additionalInfo', true);
    this.steps.set('resume', true);
  }

  sendRequest(newRequestData: any) {
    const dialogRef = this.dialog.open(ModalConfirmRequestComponent);
    dialogRef.componentInstance.submitRequestEmitter.subscribe(() => {
      this.loading = true;
      this.coreService.newOrder(newRequestData).subscribe({
        next: () => {
          /*this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestOk'),
              redirect: true,
              list: true,
              theme: 'ligth'
            }
          });*/
          this.loading = false;
          if (newRequestData && newRequestData.campaignRequestData) {
            const queryParams = {
              orderType: newRequestData.campaignRequestData.orderType,
              orderSubType: newRequestData.campaignRequestData.orderSubType,
              substitutionRequestNumber:
                newRequestData.campaignRequestData.replacedVehicle
                  ?.requestNumber
            };
            this.router.navigate(['request-completed'], { queryParams });
          }
        },
        error: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestKO'),
              close: true,
              theme: 'ligth'
            },
            disableClose: true
          });
        }
      });
    });
  }

  @HostListener('window:resize')
  onResize() {
    this.adjustStepper();
  }

  adjustStepper() {
    const stepperHeaderContainer: any = document.querySelector(
      '.mat-horizontal-stepper-header-container'
    );
    if (stepperHeaderContainer) {
      //scale 0.8
      stepperHeaderContainer.style.transform = 'scale(0.8)';
      stepperHeaderContainer.style.transformOrigin = 'center right';

      const offY = stepperHeaderContainer.offsetHeight / 2;

      const stepperHeader = this.stepperHeader.nativeElement;
      const x = stepperHeader.getBoundingClientRect().x;

      const right = window.innerWidth - x;
      stepperHeaderContainer.style.position = 'absolute';
      stepperHeaderContainer.style.top = stepperHeader.offsetTop - offY + 'px';
      stepperHeaderContainer.style.right = right + 'px';
    }
    if (stepperHeaderContainer && window.innerWidth <= 1024) {
      stepperHeaderContainer.style.transformOrigin = 'center left';
      stepperHeaderContainer.style['flex-wrap'] = 'wrap';
      stepperHeaderContainer.style.position = 'unset';
    }
  }

  goHome() {
    this.router.navigateByUrl('/landing-leasing');
  }
}
